import {
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { fetchEvent } from '@/api/event.ts';
import { EventResponse } from '@/api/event.types.ts';
import { ApiError } from '@/api/error/api.errors.ts';

const useEventQuery = (
  eventId: string,
): UseSuspenseQueryResult<EventResponse, ApiError> => {
  return useSuspenseQuery({
    staleTime: Infinity,
    gcTime: Infinity,
    queryKey: ['event', eventId],
    queryFn: () => fetchEvent(eventId),
  });
};

const getQueryKey = (eventId: string) => {
  return ['event', eventId];
};
useEventQuery.getQueryKey = getQueryKey;

export default useEventQuery;
